import { useNavigate } from "react-router-dom";



export function QuestionsList({questionsData}) {
    const navigate = useNavigate();
   
    return (
        <div className="questionsBodyContent">
            <div className="questionsCount">{questionsData.length} Questions</div>
            <div>
                {questionsData.map((question, index) => {
                    return (
                        <div className="questionsContent" key={index}>
                            <div className="questions-left-part">
                                <div className="votes">{question.votes} votes</div>
                                <div className="answers">{question.Answers ? question.Answers.length : 0} answers</div>
                                <div className="views">{question.views} views</div>
                            </div>
                            <div className="questions-main-part">
                                <div className="questionTitle" onClick={() => navigate(`${question.question_id}`)}>{question.question_title}</div>
                                <div className="questionBody">{question.question_body}</div>
                                <div className="questionsContentFooter">
                                    <div className="questionTagsWrapper">
                                        {question.tags.map((tag, index) => {
                                            return (
                                                <div className="questionTag" key={index}>{tag}</div>
                                            );
                                        })}
                                    </div>
                                    <div className="askedBy">{question.posted_by} <span>asked</span></div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
